import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import IVButton from '@invideoio/uniformd/components/Button';
import ivclass from '../../../Modules/IVClass';
import MobileMenu from './Menu';
import HeaderConfig from '../../../constants/header';
import HeaderItemIcon from '../HeaderItemIcon';
import MobileUpgradeButton from '../../AppHeader/components/MobileUpgradeButton';
const MobileHeader = (props) => {
    const { onLogin, onSignUp, os, platform, menu, logoRedirectURL, state, handleClickUpgrade, renderProps, logoURL, logoClassName, logoutRedirectLink, authFunctions, } = props;
    const [openMenu, setOpenMenu] = useState(false);
    const isPaidUser = useMemo(() => {
        const userPlan = state.user?.payment_plan;
        if (userPlan) {
            return !(userPlan === 'BUSINESS_WATERMARK' ||
                userPlan === 'BUSINESS_TRIAL' ||
                userPlan === 'PROFESSIONAL' ||
                userPlan === 'FILMR_PRO');
        }
        return false;
    }, [state.user]);
    const openModal = () => {
        setOpenMenu(true);
    };
    const closeModal = () => {
        setOpenMenu(false);
    };
    const handleLogin = () => {
        onLogin();
        closeModal();
    };
    const handleSignUp = () => {
        onSignUp();
        closeModal();
    };
    const onClickUpgrade = () => {
        handleClickUpgrade && handleClickUpgrade();
    };
    const brandLogoURL = logoURL ?? state.siteConfig?.brand?.purpleLogoURL;
    return (_jsxs(React.Fragment, { children: [_jsx("header", { className: ivclass('iv-sticky sm:iv-relative', 'iv-top-0', 'iv-z-40', 'iv-bg-white-75 dark:iv-bg-black-75', 'iv-px-20'), children: _jsx("div", { className: ivclass('iv-container', 'iv-mx-auto'), children: _jsx("div", { className: ivclass('iv-grid', 'sm:iv-grid-cols-4 md:iv-grid-cols-8 lg:iv-grid-cols-12 xl:iv-grid-cols-12', 'sm:iv-gap-20 md:iv-gap-25 lg:iv-gap-40 xl:iv-gap-40'), children: _jsxs("div", { className: ivclass('iv-flex', 'sm:iv-col-span-4 md:iv-col-span-8 lg:iv-col-start-2 lg:iv-col-span-10 xl:iv-col-start-2 xl:iv-col-span-10', 'iv-justify-between iv-items-center', 'iv-h-[56px]', 'sm:iv-px-5 md:iv-px-5 lg:iv-px-15'), children: [_jsx("a", { href: logoRedirectURL, target: "_self", className: ivclass('iv-text-body-3xl', 'iv-m-body-3xl', 'iv-font-bold'), children: _jsx("img", { height: "26", width: "83.78", src: brandLogoURL, alt: "invideo logo", className: logoClassName ? logoClassName : 'iv-h-[26px] iv-w-[83.78px]' }) }), _jsxs("div", { className: ivclass('iv-flex iv-gap-20'), children: [renderProps && renderProps(), state.user &&
                                            !isPaidUser &&
                                            typeof handleClickUpgrade === 'function' && (_jsx(MobileUpgradeButton, { handleClickUpgrade: onClickUpgrade })), _jsx(IVButton, { onClick: openModal, children: _jsx(HeaderItemIcon, { icon: HeaderConfig.BAR_ICON_MOBILE, className: "" }) })] })] }) }) }) }), openMenu && (_jsx(MobileMenu, { menu: menu, onClose: closeModal, onLogin: handleLogin, onSignUp: handleSignUp, os: os, platform: platform, logoutRedirectLink: logoutRedirectLink, authFunctions: authFunctions }))] }));
};
export default MobileHeader;
